<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5" v-if="form != null">
          <div class="card-content">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.filter_name"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter for</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                  v-model="form.filter_tbl"
                  v-validate="'required'"
                  name="m"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in tblList"
                  />
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('m')">{{
                  errors.first("m")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Listing Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="active"
                      >Active</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="inactive"
                      >Inactive</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="active"
                      >Active</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="inactive"
                      >Inactive</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Admin Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="admin_status"
                      v-model="form.admin_status"
                      vs-value="active"
                      >Active</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="admin_status"
                      v-model="form.admin_status"
                      vs-value="inactive"
                      >Inactive</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Update</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
export default {
  components: {},
  props: ["id"],
  data: () => ({
    valid: true,
    form: null,
    admin_status: "inactive",
    listing_status: "inactive",
    publish_status: "inactive",
    tblList: [
      { name: "Booth", value: "booth" },
      { name: "Company", value: "company" },
      { name: "Speaker", value: "speaker" },
      { name: "Sponsor", value: "sponsor" },
    ],
  }),
  created() {
    setTimeout(() => {
      Service.Filter.get(this.id, this.$route.query.e).then((res) => {
        this.form = res.data.filter;
        this.form.admin_status =
          this.form.admin_status === true ? "active" : "inactive";
        this.form.listing_status =
          this.form.listing_status === true ? "active" : "inactive";
        this.form.publish_status =
          this.form.publish_status === true ? "active" : "inactive";
      });
    }, 1000);
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        ...this.form,
      };

      data.admin_status = data.admin_status == "active" ? true : false;
      data.listing_status = data.listing_status == "active" ? true : false;
      data.publish_status = data.publish_status == "active" ? true : false;

      this.$vs.loading();
      Service.Filter.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          this.$router.push("/conferences/filters");
        }
        this.$vs.loading.close();
      });
    },
  },
};
</script>